export const SimpleMarkdown = (markdown) => {
  if (!markdown) return <div className='text-gray-500'>-</div>

  // Strip all HTML tags to prevent XSS
  const sanitizedMarkdown = markdown.replace(/<[^>]*>/g, '')
  const lines = sanitizedMarkdown.split('\n')

  return (
    <div className='space-y-2 bg-white'>
      {lines.map((line, index) => {
        if (line === '&nbsp;' || line === '') {
          return <br key={index} />
        } else {
          return (
            <div key={index} className='text-sm'>
              {line}
            </div>
          )
        }
      })}
    </div>
  )
}
